import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const Message: FunctionalComponent = props => {
  return (
    <div class={styles.message}>
      <div class={styles.inner}>
        {props.children}
      </div>
    </div>
  )
}
